<template>
  <div id="contenedor-listado-contrato-archivos-contratista-mobile">
    <v-list>
      <template v-for="(archivos, tipo) in archivosPorTipoOrdenado" >
        <template>
          <v-list-group
          :key="tipo || 'sin-tipo'"
          :value="false"
          no-action
          :prepend-icon="tipo ? 'mdi-folder' : 'mdi-alert-circle-outline'"
        >
          <template v-slot:activator>
            <v-list-item-title>
              <v-row align="center">
              {{ tipo || 'Sin Clasificar' }}
              <v-chip class="ml-4" small>
                {{ archivos.length }}
              </v-chip>
              </v-row>
            </v-list-item-title>
          </template>
          <template v-for="archivo in archivos">
            <template>
              <v-hover v-slot="{ hover }"  :key="archivo.id">
              <v-list-item :class="{ 'grey lighten-4': hover }">
                <v-list-item-avatar>
                  <v-icon color="primary">
                    {{ $iconoDeExtension(archivo.datosArchivo.extension) }}
                  </v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>
                    <span>
                      {{ archivo.descripcion }}
                    </span>
                  </v-list-item-title>
                  <v-list-item-subtitle class="caption">
                    {{ $moment(archivo.fecha).format("DD/MM/YYYY") }} -
                    <span>
                      <FechaHumano :fecha="archivo.createdAt"></FechaHumano>
                    </span>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    Tamaño de archivo: {{ $humanFileSize(archivo.datosArchivo.size) }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <div class="d-flex">
                    <div v-if="!soloLectura">
                      <v-btn rounded text class="text-capitalize" color="warning"
                        @click="notificar(archivo)">
                        <v-icon left small>
                          mdi-bell-ring
                        </v-icon>
                        Notificar
                      </v-btn>
                    </div>
                    <div>
                      <v-btn
                        @click="descargar(archivo.id)"
                        :loading="archivo.descargandoArchivo"
                        icon
                      >
                        <v-icon color="blue">mdi-cloud-download</v-icon>
                      </v-btn>
                    </div>
                    <div>
                      <v-btn v-if="!soloLectura" @click="borrar(archivo)" icon>
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </v-list-item-action>
              </v-list-item>
            </v-hover>
            </template>
            <template>
              <v-divider :key="`divider-${archivo.id}`"></v-divider>
            </template>
          </template>
        </v-list-group>
        </template>
      </template>
    </v-list>
  </div>
</template>

<script>
import fileDownload from 'js-file-download';
import mixArchivosContratista from '@/components/administracion/contratos/contrato/archivoscontratista/mixArchivosContratista';
import FechaHumano from '@/components/FechaHumano.vue';
import eventBus from '@/helpers/eventBus';

const BASE_URL = process.env.NODE_ENV !== 'production'
  ? 'http://localhost:3001'
  : 'https://sideop-file-server.hermosillo.gob.mx';

export default {
  name: 'listadoContratoArchivosContratistaMobile',
  mixins: [mixArchivosContratista],
  props: {
    listadoArchivos: {
      type: Array,
      required: true,
    },
    soloLectura: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    FechaHumano,
  },
  computed: {
    archivosPorTipo() {
      return this.listadoArchivos.reduce((acumulador, archivo) => {
        const tipo = archivo.tipoArchivo?.descripcion || 'Sin Clasificar';
        const orden = archivo.tipoArchivo?.orden || Infinity;
        const tipoActual = acumulador[tipo] || { archivos: [], orden };

        return {
          ...acumulador,
          [tipo]: {
            orden: tipoActual.orden,
            archivos: [...tipoActual.archivos, archivo],
          },
        };
      }, {});
    },
    archivosPorTipoOrdenado() {
      return Object.entries(this.archivosPorTipo)
        .filter(([, { archivos }]) => archivos.length > 0) // Filtra tipos sin archivos
        .sort(([, a], [, b]) => a.orden - b.orden) // Ordena por el campo `orden`
        .reduce((acumulador, [tipo, { archivos }]) => {
          return {
            ...acumulador,
            [tipo]: archivos,
          };
        }, {});
    },
  },
  methods: {
    async descargar(idArchivo) {
      const archivoDescargar = this.listadoArchivos.find((archivo) => archivo.id === idArchivo);
      if (!archivoDescargar) return;
      archivoDescargar.descargandoArchivo = true;
      await this.axios.get(
        `${BASE_URL}/${archivoDescargar.datosArchivo.public_key}`,
        {
          responseType: 'blob',
        },
      )
        .then((res) => {
          fileDownload(res.data, `${archivoDescargar.contrato.numero} - ${archivoDescargar.descripcion}.${archivoDescargar.datosArchivo.extension}`);
        })
        .catch((err) => {
          this.mixMensajeError(err.data.message);
        });
      archivoDescargar.descargandoArchivo = false;
    },
    notificar(archivo) {
      eventBus.$emit('notificar-archivo', archivo);
    },
    borrar(archivo) {
      eventBus.$emit('eliminar-archivo', archivo);
    },
  },
};
</script>

<style lang="scss"></style>
